import React from "react";
import Filters from "./Filters";
import ListTemplate, { listTemplateQueryKey } from "components/ListTemplate";
import { cardLayout } from "./cardLayout";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useQueryClient } from "@tanstack/react-query";
import FlightApp from "flights/new/app";
import TrainModal from "train/TrainModal";
import { useLoaderData } from "react-router";

const FlightListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.FlightListFrontModel>();

  const queryClient = useQueryClient();

  const onShowChange = () => {
    queryClient.invalidateQueries([listTemplateQueryKey]);
  }

  return <>
    <FlightApp />
    <TrainModal />
    <ListTemplate
      title={RESX.Flight.Flights}
      filterSet="flight_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.Flight.Paginated}
      getId={item => item.segment.id}
      layout={cardLayout(onShowChange)}
      filters={<Filters />}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
    />
  </>
};

export default FlightListApp;
